<template>
    <v-dialog :value="true" content-class="reset-cloud-dialog-container" persistent>
        <div class="white reset-cloud-dialog-contents">

            <v-btn fab flat small absolute top right @click="$emit('input', false)" style="border: none!important; border-radius: 50%; background: #ccc; margin: 0; padding: 0; text-align: center; top: 16px; width: 32px; height: 32px;">
                <v-icon style="margin-right: 0!important;">close</v-icon>
            </v-btn>

            <b class="blue--text" style="text-transform: uppercase; font-size: 16px;">{{ $t("settings.use_cloud_save") }}</b>

            <br/><br/>

            {{ $t('settings.cloud_save_desc') }}

             <v-text-field
                     :placeholder="$t('settings.cloud_save_code')"
                v-model="pin"
                maxlength="6"
                class="text-field--f38"
                hide-details
                @blur="$emit('blurred')"
        />


            <v-btn outline :loading="loading" @click="loadData">
                <v-icon>cloud_download_outline</v-icon>
                {{ $t('settings.btn_load') }}
            </v-btn>
        </div>
    </v-dialog>
</template>
<style>
    .reset-cloud-dialog-container {
        max-width: 300px;
    }
    .reset-cloud-dialog-contents {
        padding: 20px;
        text-align: center;
        position: relative;
    }
    .reset-cloud-dialog-contents .text-field--f38 {
        margin-bottom: 20px;
    }
    .reset-cloud-dialog-contents .text-field--f38 input {
        font-size: 38px;
        max-height: 50px;
        letter-spacing: 8px;
        text-align: center;
    }
    .reset-cloud-dialog-contents .text-field--f38 input::placeholder {
        font-size: 14px;
         letter-spacing: 0px;
        color: #777;
    }

    .reset-cloud-dialog-contents .v-btn {
        margin-top: 10px;
        border: 2px solid #555!important;
        border-radius: 16px;
    }
    .reset-cloud-dialog-contents .v-btn .v-icon {
        margin-right: 14px;
    }
</style>
<script>
    export default {
        data() {
            return({
                pin: "",
                activeInput: false,
                loading: false,
            });
        },
        methods: {
            onFocus($event) {
                this.activeInput = true;
            },
            loadData() {
                if (this.$store.state.networkStatus === "offline") {
                    this.$bus.$emit("app.showSnackbar", {color: "blue", text: this.$t("core.offline")});
                    return;
                }
                this.loading = true;


                fetch("https://dev.planmaster.hu/cloud-save/" + this.pin + ".json")
                    .then(response => response.json())
                    .then((data) => {
                        this.loading = false;
                        this.applySettings(data);
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.$bus.$emit("app.showSnackbar", {text: this.$t("settings.error_loading_settings")});
                        captureException(error);
                    });
            },
            applySettings(resp) {
                if (typeof resp.dentalStates !== 'undefined') {
                    this.$store.state.localSettings.dentalStates = resp.dentalStates;
                    this.$store.state.dentalStates = this.$store.state.localSettings.dentalStates;
                }
                if (typeof resp.protocols !== 'undefined') this.$store.state.localSettings.protocols = protocols;
                localStorage.setItem("settings", JSON.stringify(this.$store.state.localSettings));
                this.$bus.$emit("app.showSnackbar", {text: this.$t("settings.cloud_save_applied")});
                this.$emit('input', false);
            },
            updateProtocols(stored) {
                const localProtocols = JSON.parse(JSON.stringify(protocols));
                Object.keys(stored).forEach((key) => {
                    if (typeof stored[key].variations === "undefined") {
                        // return;
                    }

                    // protocols[key].variations = stored[key].variations;
                    localProtocols[key].active = stored[key].active;
                    localProtocols[key].variation_active = stored[key].variation_active;
                    localProtocols[key].variation_titles = stored[key].variation_titles;
                    localProtocols[key].variation_prices = stored[key].variation_prices;
                });
                this.$store.state.localSettings.protocols = localProtocols;
            },
        },
    }
</script>
